import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';

type NavigationTabsClientProps = NavigationTabsPropsHelper<{
    mid: string;
}>;

const NavigationTabsClient: FC<NavigationTabsClientProps> = ({
    className,
    mid,
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            <BaseNavigationTabsButton
                href={window.Urls.client_summary_view(mid)}
                label={t('client.summary')}
                name="summary"
            />
            <BaseNavigationTabsButton
                href={window.Urls.client_contact_view(mid)}
                label={t('client.contact')}
                name="contact"
            />
            <BaseNavigationTabsButton
                href={window.Urls.client_contact_history_view(mid)}
                label={t('client.clientHistory')}
                name="clientHistory"
            />
            <BaseNavigationTabsButton
                href={window.Urls.client_securesend_view(mid)}
                label={t('client.sendingSettings')}
                name="sendingSettings"
            />
            <BaseNavigationTabsButton
                href={window.Urls.client_document_send_view(mid)}
                label={t('client.documents')}
                name="documents"
            />
            <BaseNavigationTabsButton
                href={window.Urls.client_notes(mid)}
                label={t('client.notes')}
                name="notes"
            />
        </BaseNavigationTabs>
    );
};

export default NavigationTabsClient;
